var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("article", [
    _c(
      "div",
      {
        class: [
          "tabs",
          _vm.bgType ? "bg-type" : "",
          _vm.cssType == "" ? "" : "--" + _vm.cssType
        ]
      },
      [
        _vm._l(_vm.titleList, function(data, index) {
          return _c(
            "button",
            {
              key: index,
              class: [
                "tab-button",
                _vm.cssType == "" ? "tab-button--type1" : "",
                _vm.currentTab === index ? "active" : ""
              ],
              on: {
                click: function($event) {
                  return _vm.tabClick(index)
                }
              }
            },
            [
              typeof _vm.tabIcon == "object" &&
              !_vm._.isNil(_vm.tabIcon[index]) &&
              !_vm._.isEmpty(_vm.tabIcon[index])
                ? _c("i", { staticClass: "icon", class: _vm.tabIcon[index] })
                : typeof _vm.tabIcon == "string" &&
                  !_vm._.isNil(_vm.tabIcon) &&
                  !_vm._.isEmpty(_vm.tabIcon)
                ? _c("i", { staticClass: "icon", class: _vm.tabIcon })
                : _vm._e(),
              _vm._v(" " + _vm._s(_vm.$t(data)) + " ")
            ]
          )
        }),
        _vm._t("other")
      ],
      2
    ),
    Object.keys(_vm.$slots).length > 0
      ? _c(
          "div",
          _vm._l(this.$slots, function(content, index) {
            return _c(
              "div",
              { key: index },
              [_vm.currentTab == index ? _vm._t(index) : _vm._e()],
              2
            )
          }),
          0
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }